import Model from '@/models/Model.js';

export default class SlideDeckActivityTemplate extends Model {
    static entity = 'slide_deck_activity_templates';

    static modelName = 'SlideDeckActivityTemplate';

    static fields() {
        return {
            content: this.attr(null),
            slide_deck_id: this.attr(null),
            acknowledgment_message: this.attr(null),

            ...super.fields(),
        };
    }
}
